import React from 'react';
import { Divider as Component } from 'wix-ui-tpa/cssVars';
import { VIEWER_HOOKS } from '@wix/pricing-plans-common/hooks';
import { classes } from './TitleDivider.st.css';

export const TitleDivider = () => (
  <Component className={classes.root} data-hook={VIEWER_HOOKS.TITLE_DIVIDER} direction="horizontal" />
);
